var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcTick = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3754 29.0322L36.3291 11.0793L38.9217 13.6721L19.6717 32.9213C18.9558 33.6372 17.7951 33.6372 17.0791 32.9213L7.4541 23.2972L10.0467 20.7043L18.3754 29.0322Z",
    fill: "#07794C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_tick.56e568d9.svg";
export { ForwardRef as ReactComponent };